<div nxLayout="grid maxwidth" class="contact-us">
    <div nxRow>
        <div nxCol="12" class="docs-grid-colored-col">
            <div nxRow>
                <div nxCol="12">

                    <section>
                        <h3 nxHeadline="subsection-medium" translate>contact-us.call-us.section-name</h3>
                        <nx-card class="call-us-card">
                            <div nxRow>
                                <div nxCol="11" colOffset="1">
                                    <h3 nxHeadline="subsection-small" class="nx-font-weight-light" translate>
                                        contact-us.call-us.headline
                                    </h3>
                                </div>
                                <div nxCol="11,11,11,5" colOffset="1">
                                    <div class="call-center">
                                        <div class="icon">
                                            <cpc-icon icon='phone-o' borderStyle='circle' backgroundColor='#fff'
                                                style="font-size: 64px">
                                            </cpc-icon>
                                        </div>
                                        <div class="call-center-text">
                                            <h4 nxHeadline="subsection-small" class="nx-font-weight-light"><span
                                                    translate>contact-us.call-us.call-center</span>:</h4>
                                            <h4 nxHeadline="subsection-small" class="nx-font-weight-bold"><a
                                                    href="{{'tel:'}}{{'contact-us.call-us.phone-number' | translate}}"
                                                    translate>contact-us.call-us.phone-number</a></h4>
                                            <p><span translate>contact-us.call-us.opening-hours.week</span><br><span
                                                    translate>contact-us.call-us.opening-hours.weekend</span><br><span
                                                    translate>contact-us.call-us.opening-hours.notice</span></p>
                                        </div>
                                    </div>
                                </div>
                                <div nxCol="12,12,12,4" colOffset="0,0,0,1">
                                    <div class="woman-illustration">
                                        <cpc-illustration name="womanWithLaptopTalkingOnThePhone" width="362px">
                                        </cpc-illustration>
                                    </div>
                                </div>
                            </div>
                        </nx-card>
                    </section>
                </div>
            </div>

            <div nxRow>
                <div nxCol="12">
                    <section>
                        <h3 nxHeadline="subsection-medium" translate>contact-us.call-me-back.section-name</h3>
                        <nx-card class="call-me-back-card">
                            <div nxRow nxRowAlignItems="center">
                                <div nxCol="12,12,12,1" colOffset="0,0,0,1">
                                    <div nxRow nxRowAlignItems="center" class="mob-call-me-back">
                                        <div nxCol="6,3,2,2">
                                            <div class="icon">
                                                <cpc-icon icon='Callback' borderStyle='circle' backgroundColor='#f1f9fa'
                                                    style="font-size: 64px">
                                                </cpc-icon>
                                            </div>
                                        </div>
                                        <div nxCol="6,8,8,8" class="mob-info-text" *ngIf="!formBEValid">
                                            <p translate>contact-us.call-me-back.text</p>
                                        </div>
                                    </div>
                                </div>

                                <div nxCol="12,12,12,9">
                                    <div class="call-me-back-text info-text">
                                        <p *ngIf="!formBEValid" translate>contact-us.call-me-back.text</p>

                                        <div nxLayout="grid" *ngIf="!formBEValid">
                                            <form [formGroup]="form" (submit)="submit($event)">
                                                <div nxRow nxRowAlignItems="center">
                                                    <div nxCol="12,12,12,4">
                                                        <div nxRow nxRowAlignItems="center">
                                                            <div nxCol="12">
                                                                <nx-formfield
                                                                    label="{{ 'callMeBack.topicLabel' | translate }}">
                                                                    <nx-dropdown formControlName="topic"
                                                                        (ngModelChange)="topicBind()" #topicSelect>
                                                                        <ng-template ngFor let-topicData="$implicit"
                                                                            [ngForOf]="topicData|keyvalue">
                                                                            <nx-dropdown-item
                                                                                value="{{ topicData.value.id }}">{{ topicData.value.name|translate}}
                                                                            </nx-dropdown-item>
                                                                        </ng-template>
                                                                    </nx-dropdown>
                                                                    <nx-error nxFormfieldError
                                                                        *ngIf="form.get('topic')?.errors?.valid == false"
                                                                        translate>
                                                                        <span translate>callMeBack.invalidField</span>
                                                                    </nx-error>
                                                                </nx-formfield>
                                                            </div>
                                                            <div nxCol="12" *ngIf="topicSelect.value == 3">
                                                                <nx-radio-group formControlName="policy"
                                                                    (groupValueChange)="policyBind($event.value)">
                                                                    <ng-template ngFor let-policy="$implicit"
                                                                        [ngForOf]="policies|keyvalue">
                                                                        <nx-radio class="nx-margin-bottom-m"
                                                                            value="{{ policy.value.policyNumber }}">
                                                                            <div class="radio-with-icon">
                                                                                <div>
                                                                                    <cpc-icon left
                                                                                        [icon]="getGroupByLobId(policy.value.lineOfBusinessId).icon"
                                                                                        color="#006192"
                                                                                        borderStyle="circle"
                                                                                        backgroundColor="#fff"></cpc-icon>
                                                                                    <span>{{ policy.value.policyNumber }}</span>
                                                                                </div>
                                                                                <div class="policy-detail"
                                                                                    id="{{ policy.value.policyNumber }}">
                                                                                    <span>
                                                                                        {{'active-insurance-group.' + getGroupByLobId(policy.value.lineOfBusinessId).name | translate}}
                                                                                        <div
                                                                                            [ngSwitch]="LOB.setId(policy.value.lineOfBusinessId).lob">
                                                                                            <b
                                                                                                *ngSwitchCase="lob.CarInsurance">{{policy.value.model | stringFormat}}&nbsp;-
                                                                                                {{policy.value.crn | stringFormat}}</b>
                                                                                            <b
                                                                                                *ngSwitchCase="lob.LifeInsurance">{{policy.value.firstInsuredName | stringFormat}}</b>
                                                                                            <b
                                                                                                *ngSwitchCase="lob.HomeInsurance">{{policy.value.householdAddress | stringFormat}}</b>
                                                                                        </div>
                                                                                        {{ 'home.product-name' | translate }}:
                                                                                        <b>{{ policy.value.productNameSpecific }}</b>
                                                                                        <br>
                                                                                        {{ 'policy.policy-number' | translate }}:
                                                                                        <b>{{policy.value.policyNumber}}</b>
                                                                                        <br>
                                                                                        {{'policy.start-date' | translate}}:
                                                                                        <b>
                                                                                            {{ policy.value.beginDate | dateFormat }}</b>
                                                                                        <br>
                                                                                        {{ 'policy.end-date' | translate }}:
                                                                                        <b>{{ policy.value.endDate | dateFormat }}</b>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </nx-radio>
                                                                    </ng-template>
                                                                </nx-radio-group>
                                                            </div>

                                                            <div nxCol="12" *ngIf="topicSelect.value == 774">
                                                                <nx-radio-group formControlName="claim"
                                                                    (groupValueChange)="claimBind($event.value)">
                                                                    <ng-template ngFor let-claim="$implicit"
                                                                        [ngForOf]="claims|keyvalue">
                                                                        <nx-radio class="nx-margin-bottom-m"
                                                                            value="{{ claim.value.claim.claimNumber }}">
                                                                            <div class="radio-with-icon">
                                                                                <div>
                                                                                    <cpc-icon left
                                                                                        [icon]="claim.value.icon"
                                                                                        color="#006192"
                                                                                        borderStyle="circle"
                                                                                        backgroundColor="#fff"></cpc-icon>
                                                                                    <span>{{ claim.value.claim.claimNumber }}</span>
                                                                                </div>
                                                                                <div class="policy-detail"
                                                                                    id="{{ claim.value.claim.claimNumber }}">
                                                                                    <span>
                                                                                        {{ 'policy.policy-number' | translate }}:
                                                                                        <b>{{claim.value.claim.policyNumber}}</b>
                                                                                        <br>
                                                                                        {{'claim.event-date' | translate}}:
                                                                                        <b>
                                                                                            {{ claim.value.claim.eventDate | dateFormat }}</b>
                                                                                        <br>
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                        </nx-radio>
                                                                    </ng-template>
                                                                </nx-radio-group>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div nxCol="12,12,12,3">
                                                        <nx-formfield
                                                            label="{{ 'callMeBack.dateFieldLabel' | translate }}">
                                                            <input nxDatefield nxInput [datepicker]="dateDatepicker"
                                                                [datefieldFilter]="filterDate" formControlName="date"
                                                                [parseFormat]="['DD.MM.YYYY', 'D.M.YYYY']"
                                                                displayFormat="DD.MM.YYYY"
                                                                (ngModelChange)="timeBind()" />

                                                            <nx-datepicker-toggle [for]="dateDatepicker"
                                                                nxFormfieldSuffix></nx-datepicker-toggle>
                                                            <nx-datepicker #dateDatepicker></nx-datepicker>
                                                            <nx-error nxFormfieldError
                                                                *ngIf="form.get('date')?.errors?.valid == false"
                                                                translate>
                                                                <span translate>callMeBack.invalidField</span>
                                                            </nx-error>
                                                            <nx-error nxFormfieldError
                                                                *ngIf="form.get('date')?.errors?.history" translate>
                                                                <span translate>callMeBack.historyField</span>
                                                            </nx-error>
                                                            <nx-error nxFormfieldError
                                                                *ngIf="form.get('date')?.errors?.future" translate>
                                                                <span translate>callMeBack.futureField</span>
                                                            </nx-error>
                                                            <nx-error nxFormfieldError
                                                                *ngIf="form.get('date')?.errors?.holiday" translate>
                                                                <span translate>callMeBack.holidayField</span>
                                                            </nx-error>

                                                        </nx-formfield>
                                                    </div>

                                                    <div nxCol="12,12,12,3">
                                                        <nx-formfield
                                                            label="{{ 'callMeBack.hourFieldLabel' | translate }}">
                                                            <nx-dropdown formControlName="hour">
                                                                <ng-template ngFor let-hourData="$implicit"
                                                                    [ngForOf]="hourDataArray">
                                                                    <nx-dropdown-item
                                                                        value="{{hourData}}"></nx-dropdown-item>
                                                                </ng-template>
                                                            </nx-dropdown>
                                                            <nx-error nxFormfieldError
                                                                *ngIf="form.get('hour')?.errors?.valid == false"
                                                                translate>
                                                                <span translate>callMeBack.invalidField</span>
                                                            </nx-error>
                                                            <nx-error nxFormfieldError
                                                                *ngIf="form.get('hour')?.errors?.history" translate>
                                                                <span translate>callMeBack.historyField</span>
                                                            </nx-error>
                                                        </nx-formfield>
                                                    </div>

                                                    <div nxCol="12,12,12,2">
                                                        <button nxButton="primary small" type="submit"
                                                            [disabled]="this.form.valid ? null : ''"><span
                                                                translate>callMeBack.submitBtnText</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div nxLayout="grid" *ngIf="formBEValid">
                                            <div nxRow>
                                                <div nxCol="12" style="text-align: center;">
                                                    <p nxCopytext translate>callMeBack.successText</p>
                                                    <button nxButton="primary small" type="button"
                                                        (click)="newRequest()"><span
                                                            translate>callMeBack.newRequest</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nx-card>
                    </section>
                </div>
            </div>

            <div nxRow>
                <div nxCol="12">
                    <section>
                        <h3 nxHeadline="subsection-medium" translate>contact-us.faq.section-name</h3>
                        <nx-card class="faq-card">
                            <div nxRow nxRowAlignItems="center">

                                <div nxCol="12,12,12,1" colOffset="0,0,0,1">
                                    <div nxRow nxRowAlignItems="center" class="mob-faq">
                                        <div nxCol="6,3,2,2">
                                            <div class="icon">
                                                <cpc-icon icon='speech-bubble-o' borderStyle='circle'
                                                    backgroundColor='#f1f9fa' style="font-size: 64px">
                                                </cpc-icon>
                                            </div>
                                        </div>
                                        <div nxCol="6,8,8,8" class="mob-info-text">
                                            <p translate>contact-us.faq.text</p>
                                        </div>
                                    </div>
                                </div>
                                <div nxCol="11,11,11,9" colOffset="1,1,1,0">
                                    <div class="faq-text info-text">
                                        <p translate>contact-us.faq.text</p>
                                        <a href="{{'contact-us.faq.btnUrl' | translate}}" target="_blank">
                                            <button type="button" nxButton="primary small">
                                                {{'contact-us.faq.btnText' | translate}}
                                            </button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </nx-card>
                    </section>
                </div>
            </div>

            <!-- email us -->
            <div nxRow>
                <div nxCol="12">
                    <section>
                        <h3 nxHeadline="subsection-medium" translate>contact-us.email-us.section-name</h3>
                        <nx-card class="email-us-card">
                            <div nxRow nxRowAlignItems="center">

                                <div nxCol="12,12,12,1" colOffset="0,0,0,1">
                                    <div nxRow nxRowAlignItems="center" class="mob-email-us">
                                        <div nxCol="6,3,2,2">
                                            <div class="icon">
                                                <cpc-icon icon='mail-o' borderStyle='circle' backgroundColor='#f1f9fa'
                                                    style="font-size: 64px">
                                                </cpc-icon>
                                            </div>
                                        </div>
                                        <div nxCol="6,8,8,8" class="mob-info-text">
                                            <p translate>contact-us.email-us.text</p>
                                        </div>
                                    </div>
                                </div>
                                <div nxCol="11,11,11,9" colOffset="1,1,1,0">
                                    <div class="email-us-text info-text">
                                        <p translate>contact-us.email-us.text</p>
                                        <a [routerLink]="['/inbox/napiste-nam']">
                                            <button type="button" nxButton="primary small">
                                                {{'contact-us.email-us.btnText' | translate}}
                                            </button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </nx-card>
                    </section>
                </div>
            </div>

            <div nxRow>
                <div nxCol="12">
                    <section>
                        <h3 nxHeadline="subsection-medium" translate>contact-us.my-agent.section-name</h3>
                        <nx-card class="my-agent-card">
                            <cpc-agent *ngFor="let agent of agents">
                                <span name>{{agent.agentName}}</span>
                                <cpc-agent-entry>
                                    <span title translate>agent.mobile-number</span>
                                    <app-formatted-link url="{{'tel:' + agent.agentMobilAgn}}"
                                        text="{{agent.agentMobilAgn}}" class="phone"></app-formatted-link>
                                </cpc-agent-entry>
                                <cpc-agent-entry>
                                    <span title translate>agent.email</span>
                                    <app-formatted-link url="{{'mailto:' + agent.agentEmailAgn}}"
                                        text="{{agent.agentEmailAgn}}">
                                    </app-formatted-link>
                                </cpc-agent-entry>
                                <cpc-agent-entry>
                                    <span title translate>agent.website</span>
                                    <app-formatted-link url="{{agent.agentUrl}}" text="{{agent.agentUrl}}"
                                        defaultUrl="https://www.allianz.sk"></app-formatted-link>
                                </cpc-agent-entry>
                            </cpc-agent>
                        </nx-card>
                    </section>

                </div>
            </div>
        </div>
    </div>
</div>